import React from "react";
import ServicePage from "./Components/ServiceComponent";
import mobileDevImage from "../../assets/img/15917680_5666022.webp"; // Assurez-vous d'avoir une image appropriée
import backgroundMobil from "../../assets/img/hero.webp";
import {
  FaMobileAlt,
  FaReact,
  FaCode,
  FaRocket,
  FaPaintBrush,
  FaLaptop,
  FaLink,
  FaFile,
  FaMoneyBill,
} from "react-icons/fa";
import IntlMessages from "../../intl/IntlMessages";

const SocialVision = () => {
  return (
    <ServicePage
      title={<IntlMessages id="software.social" />}
      description={
        <div>
          <p>
            <IntlMessages id="visit.social" />
          </p>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <FaMobileAlt size={24} />
              <span style={{ marginLeft: "0.5rem" }}>
                <IntlMessages id="content.socialPlatform" />
              </span>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <FaLink size={24} />
              <span style={{ marginLeft: "0.5rem" }}>
                <IntlMessages id="content.socialPlatform1" />
              </span>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <FaFile size={24} />
              <span style={{ marginLeft: "0.5rem" }}>
                <IntlMessages id="content.socialPlatform2" />
              </span>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <FaMoneyBill size={24} />
              <span style={{ marginLeft: "0.5rem" }}>
                <IntlMessages id="content.socialPlatform3" />
              </span>
            </div>
          </div>
        </div>
      }
      imageUrl={mobileDevImage}
      altText={<IntlMessages id="softwareDevelopment.altText" />}
      heroBackgroundImage={backgroundMobil}
    />
  );
};

export default SocialVision;
